import { Component, OnInit } from '@angular/core';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { MenuItem } from 'src/app/misc/interface/menu-item';
import { Router } from '@angular/router';
import { ProfileImageService } from 'src/app/services/profile-image.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { DataService } from 'src/app/services/data.service';
import { local } from 'd3';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  sidebarVisible: boolean = false;
  expandedItems: { [key: string]: boolean } = {}; // Track expanded state for each item

  items: MenuItem[] = [];
  translator: TranslatorPipe = new TranslatorPipe();
  userName: string | null | undefined;
  image: string | null = null;
  managerOu: any;
  externalCoordinator: any;
  fixedTrainingItemsIds: string[] = [
    '64ecbe4ff6c283d49c8f3d61',
    '64edba9b9b8555d3669790dc',
    '654e867bb9f4c5b8996191c5',
    '655b25b65316702b1f3295c1',
  ];
  fixedTrainingItems: MenuItem[] = [];
  trainer = false;
  branchTrainer = false;

  constructor(
    private dataService: DataService,
    private permissionService: PermissionHandlerService,
    private router: Router,
    private profileService: ProfileImageService
  ) { }

  ngOnInit() {
    this.initializeData();
   }

  private async initializeData() {
    this.userName = localStorage.getItem('username');
    this.managerOu = localStorage.getItem('managerOus');
    let coordinator = localStorage.getItem('externalUser');
    this.externalCoordinator = coordinator ? JSON.parse(coordinator) : false;
    this.managerOu = this.managerOu ? JSON.parse(this.managerOu) : null;
    let img = localStorage.getItem('image');
    if (img) {
      this.image = GlobalConstants.staticFilesURL + img;
    }
    this.profileService.getImage().subscribe((image: string) => {
      this.image = image;
    });

    //trainer check
    let UserRole = '';
    const externalUserString = localStorage.getItem('externalUser');

    if (externalUserString) {
      const externalUser = JSON.parse(externalUserString);
      if (externalUser && externalUser.role) {
        UserRole = externalUser.role;
      }
    }


    let branchTrainer = localStorage.getItem('branchTrainer');
    if (!!branchTrainer && branchTrainer != 'undefined') {
      let branchTrainerData = JSON.parse(branchTrainer);
      if (branchTrainerData.status == true) {
        this.branchTrainer = true;
      }
    }

    if (UserRole == 'trainer') this.trainer = true;

    await this.getDashboards();

    this.fixedTrainingItems = [
      // {
      //   label: this.translate('Training Dashbaord'),
      //   icon: 'pi pi-fw pi-chart-line',
      //   routerLink: '/training/dashboard',
      //   visible: true
      // },
     
      // {
      //   label: this.translate('Training Program'),
      //   routerLink: '/training/program',
      //   icon: 'pi pi-fw pi-th-large',
      //   visible: this.permissionService.hasPermission('TRAINING_PROGRAM', 'r'),
      //   // visible: false,
      // },
      {
        label: this.translate('Sustainable training'),
        icon: 'pi pi-fw pi-plus-circle',
        routerLink: '/training/all-trainings',
        visible:
          this.permissionService.hasPermission('CONTINUOUS_TRAINING', 'r')
          ||
          // (this.managerOu && this.managerOu.length > 0) 
          this.trainer,
      },
      {
        label: this.translate('Browse trainings'),
        icon: 'pi pi-fw pi-flag',
        routerLink: '/training/all-trainings',
        visible: true,
      },
      {
        // <i class="fa-solid fa-building-flag"></i>
        label: this.translate('New Branch Training'),
        icon: 'fa-solid fa-building-flag',
        routerLink: '/training/new-branch',
        visible:
          this.permissionService.hasPermission('NEW_BRANCH_TRAINING', 'r') ||
          // (this.managerOu && this.managerOu.length > 0) ||
          (localStorage.getItem('master_trainer') === 'true') ||
          this.trainer,
      },
      {
        label: this.translate('Skill Training'),
        icon: 'pi pi-th-large pi-plus-circle',
        routerLink: '/training/skill-training/655b25b65316702b1f3295c1',
        visible:
          this.permissionService.hasPermission('SKILL_TRAINING', 'r') ||
          // (this.managerOu && this.managerOu.length > 0) ||
          this.trainer,
      },
      
    ];

    await this.getOuType();

    let isVendor = false;
    const isVendorString = localStorage.getItem('isVendor');

    if (isVendorString && isVendorString != 'undefined') {
      try {
        isVendor = JSON.parse(isVendorString);
      } catch (error) {
        console.error('Error parsing isVendorString:', error);
      }
    }

    const mystery_visible =
      isVendor || this.permissionService.hasPermission('MYSTERY_SHOPPER', 'r');

    this.items = [
      {
        label: this.translate('Homepage'),
        routerLink: '/home',
        icon: 'pi pi-fw pi-home',
        visible: true,
      },
      {
        label: this.translate('Profile personly'),
        routerLink: '/user-profile',
        icon: 'pi pi-fw pi-user',
        // badge: '10',
        visible: true,
      },
      {
        label: this.translate('Knowledge Library'),
        routerLink: '/knowledge-library',
        icon: 'pi pi-fw pi-book',
        // badge: '3',
        visible: this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'r'),
      },
      {
        label: this.translate('Products and Services'),
        routerLink: '/products-view',
        icon: 'fa-brands fa-servicestack',
        visible: this.permissionService.hasPermission('PRODUCT_SERVICE', 'r'),
      },
      {
        label: this.translate('Orders'),
        routerLink: '/orders',
        icon: 'pi pi-fw pi-shopping-bag',
        visible: this.permissionService.hasPermission('ORDER', 'r'),
      },     
      {
        label: this.translate('Impact Magerment Task'),
        icon: 'fa-solid fa-chart-bar',
        routerLink: '/training/impact-magerment-task',
        visible: (this.managerOu && this.managerOu.length > 0),
      },
      {
        label: this.translate('Notifications'),
        icon: 'pi pi-bell',
        routerLink: '/notification',
        visible: this.permissionService.hasPermission( 'VIEW_NOTIFICATIONS','a'),
      },
      
      {
        label: this.translate('Announcements'),
        icon: 'pi pi-megaphone',
        routerLink: '/announcement',
        visible: this.permissionService.hasPermission('ACCOUNCEMENTS', 'a'),
      },

      {
        label: this.translate('Polls'),
        icon: 'pi pi-chart-pie',
        routerLink: '/survey',
        visible: this.permissionService.hasPermission('SURVEY', 'r'),
      },
      
      {
        label: this.translate('PDF Maker'),
        icon: 'pi pi-file-pdf',
        routerLink: '/pdf-maker',
        visible: this.permissionService.hasPermission('PDF_MAKER', 'r') || this.permissionService.hasPermission('PDF_MAKER_APPROVE', 'a') || this.permissionService.hasPermission('PDF_MAKER_REVIEW', 'a'),
      },
      {
        label: this.translate('Request Permissions'),
        icon: 'fa-solid fa-person-circle-question',
        routerLink: '/permission/requests',
        visible: this.hasPermissionRequest() !== 'false',
      },
      {
        label: this.translate('Assessments'),
        icon: 'pi pi-file-edit',
        routerLink: '/assessment',
        visible: this.permissionService.hasPermission('ASSESSMENT', 'r'),
      },
      {
        label: this.translate('Mystery Shopper'),
        icon: 'pi pi-search',
        routerLink: '/ms/project',
        visible: mystery_visible,
        // visible: JSON.parse(localStorage.getItem('isVendor') ?? 'false') || this.permissionService.hasPermission('MYSTERY_SHOPPER','r')
      },
     
      



      {
        label: this.translate('System Administration'),
        icon: 'fa-solid fa-user-tie',
        // badge: '10',
        visible: this.permissionService.hasPermission('ADMIN_PERMISSION', 'a') ||
                 this.permissionService.hasPermission('ACCOUNCEMENTS', 'a') || 
                 this.permissionService.hasPermission('KNOWLEDGE_LIBRARY_APPROVAL','a') ||
                 this.permissionService.hasPermission('OU', 'r') || 
                 this.permissionService.hasPermission('THEME_SETTINGS', 'a') ||
                 this.permissionService.hasPermission('USER_MANAGEMENT','r') ||
                 this.permissionService.hasPermission('COMPANY', 'r'),
        items: [

          {
            label: this.translate('User console'),
            icon: 'pi pi-fw pi-user-plus',
            // badge: '3',
            routerLink: '/admin/users',
            visible: this.permissionService.hasPermission('USER_MANAGEMENT','r'),
          },
          {
            label: this.translate('Admin Permission Panel'),
            icon: 'pi pi-fw pi-cog',
            routerLink: '/investor-admin',
            visible: this.permissionService.hasPermission('ADMIN_PERMISSION', 'a'),
          },
          {
            label: this.translate('Announcements'),
            icon: 'pi pi-megaphone',
            routerLink: '/announcement',
            visible: this.permissionService.hasPermission('ACCOUNCEMENTS', 'a'),
          },
          
          {
            label: this.translate('KL approval'),
            icon: 'pi pi-fw pi-book',
            routerLink: '/knowledge-library/approval',
            visible: this.permissionService.hasPermission('KNOWLEDGE_LIBRARY_APPROVAL','a'),
          },
          {
            label: this.translate('Ou Management Page'),
            icon: 'pi pi-fw pi-sitemap',
            routerLink: '/admin/organization-units',
            visible: this.permissionService.hasPermission('OU', 'r'),
          },
          {
            label: this.translate('theme settings'),
            icon: 'pi pi-fw pi-moon',
            // badge: "3",
            routerLink: '/theme-settings',
            visible: this.permissionService.hasPermission('THEME_SETTINGS', 'a'),
          },
          {
            label: this.translate('Knowledge Library'),
            icon: 'pi pi-fw pi-book',
            routerLink: '/dashboard/knowledge_library',
            visible: false,
          },

        ]
      },
     
      {
        label: this.translate('Content Management'),
        icon: 'fa-solid fa-magnifying-glass-chart',
        // badge: '10',
        visible: this.permissionService.hasPermission('CONTENT_UPDATE_LOGS','r') ||
                 this.permissionService.hasPermission('PERIODIC_REPORTS','r') || this.permissionService.hasPermission('CONTENT_APPROVE', 'a') ||
                 this.permissionService.hasPermission('DATA_BULK', 'a') ||
                 this.permissionService.hasPermission('DATA', 'r') ||
                 this.permissionService.hasPermission('CONTENT', 'c') || this.permissionService.hasPermission('COMMENTS', 'r') ,
             
        items:[
          {
            label: this.translate('Load data file'),
            icon: 'pi pi-file-import',
            routerLink: '/bulk',
            visible: this.permissionService.hasPermission('DATA_BULK', 'a'),
          },
          {
            label: this.translate('Comments'),
            icon: 'pi pi-comments',
            routerLink: '/admin/comments',
            visible:
              this.permissionService.hasPermission('COMMENTS', 'c') ||
              this.permissionService.hasPermission('COMMENTS', 'u') ||
              this.permissionService.hasPermission('COMMENTS', 'd'),
          },
          {
            label: this.translate('Content update logs'),
            routerLink: '/update',
            icon: 'pi pi-fw pi-pencil',
            // badge: '3',
            visible: this.permissionService.hasPermission('CONTENT_UPDATE_LOGS','r'),
          },
          {
            label: this.translate('Data Management'),
            icon: 'pi pi-fw pi-database',
            // badge: "3",
            routerLink: '/admin/data',
            visible: this.permissionService.hasPermission('DATA', 'r'),
          },
          {
            label: this.translate('Add data'),
            icon: 'pi pi-fw pi-plus',
            routerLink: '/admin/data/add',
            visible: this.permissionService.hasPermission('CONTENT', 'c'),
          },
          {
            label: this.translate('Periodic Reports'),
            routerLink: '/periodic-reports',
            icon: 'pi pi-fw pi-file-excel',
            // badge: '3',
            visible: this.permissionService.hasPermission('PERIODIC_REPORTS','r') || this.permissionService.hasPermission('CONTENT_APPROVE', 'a')
          },

        ]
      },

      {
        label: this.translate('Training Management'),
        icon: 'fa-solid fa-magnifying-glass-chart',
        // badge: '10',
        visible:false,
        items:[

        ]
      },

      
      
      
      
      {
        label: this.translate('Training Management'),
        icon: 'pi pi-fw pi-cog',
        // badge: '12',
        visible:
          // this.permissionService.hasPermission('OU', 'r') ||
          // this.permissionService.hasPermission('USER_MANAGEMENT', 'r') ||
          // this.permissionService.hasPermission('DATA', 'r') ||
          // this.permissionService.hasPermission('COMMENTS', 'r') ||
          this.permissionService.hasPermission('COMPANY', 'r') ||
          (this.externalCoordinator?.status == true &&
            this.externalCoordinator?.role == 'Coordinator') ||
          this.permissionService.hasPermission('TRAINER', 'r')|| this.permissionService.hasPermission('BRANCH_TRAINER', 'r'),
        items: [
          {
            label: this.translate('Training Settings'),
            icon: 'pi pi-fw pi-cog',
            routerLink: '/training/type',
            visible: this.permissionService.hasPermission('TRAINING_TYPE', 'r'),
          },
         
          
          
          {
            label: this.translate('Company Trainers'),
            icon: 'fa-solid pi-fw fa-chalkboard',
            routerLink: '/coordinator-view',
            visible:
              this.externalCoordinator?.status == true &&
              this.externalCoordinator?.role == 'Coordinator',
          },
          {
            label: this.translate('Trainers'),
            icon: 'fa-solid pi-fw fa-chalkboard',
            routerLink: '/trainers',
            visible: this.permissionService.hasPermission('TRAINER', 'r'),
          },

          {
            label: this.translate('Branch Trainers'),
            icon: 'fa-solid pi-fw fa-chalkboard',
            routerLink: '/branch-trainers',
            visible:this.permissionService.hasPermission('BRANCH_TRAINER', 'r'),
            
          },
          {
            label: this.translate('External Company'),
            icon: 'pi pi-fw pi-building',
            routerLink: '/company',
            visible: this.permissionService.hasPermission('COMPANY', 'r'),
          },
        ],
      },
      // {
      //   label: this.translate('Training'),
      //   icon: 'pi pi-fw pi-flag',
      //   // badge: '12',
      //   visible:
      //     this.permissionService.hasPermission(
      //       'CONTINUOUS_TRAINING_REQUEST',
      //       'r'
      //     ) ||
      //     this.permissionService.hasPermission(
      //       'CONTINUOUS_TRAINING',
      //       'r'
      //     ) ||
      //     this.permissionService.hasPermission('NEW_BRANCH_TRAINING', 'r') ||
      //     this.permissionService.hasPermission('SKILL_TRAINING', 'r') ||
      //     this.permissionService.hasPermission('TRAINING_PROGRAM', 'r') ||
      //     // (this.managerOu && this.managerOu.length > 0) ||
      //     localStorage.getItem('master_trainer') === 'true' ||
      //     this.trainer,
      //   items: [...this.fixedTrainingItems],
      // },
      {
        label: this.translate('Training Requests'),
        icon: 'pi pi-fw pi-inbox',
        routerLink: '/training/manager-training-requests',
        visible:
          (this.managerOu && this.managerOu.length > 0) ||
          this.permissionService.hasPermission('SKILL_TRAINING_ADD_USER', 'a'),
      },
      {
        label: this.translate('Browse trainings'),
        icon: 'fa-solid fa-person-chalkboard',
        routerLink: '/training/all-trainings',
        visible: this.permissionService.hasPermission(
          'CONTINUOUS_TRAINING_REQUEST',
          'r'
        ) ||
        this.permissionService.hasPermission(
          'CONTINUOUS_TRAINING',
          'r'
        ) ||
        this.permissionService.hasPermission('NEW_BRANCH_TRAINING', 'r') ||
        this.permissionService.hasPermission('SKILL_TRAINING_PUBLISH', 'a') ||
        this.permissionService.hasPermission('PATH_PUBLISH', 'a') ||
        this.permissionService.hasPermission('PROGRAM_PUBLISH', 'a') ||
        this.permissionService.hasPermission('PATH', 'r') ||
        this.permissionService.hasPermission('SKILL_TRAINING', 'r') ||
        this.permissionService.hasPermission('TRAINING_PROGRAM', 'r') ||
        this.permissionService.hasPermission('SKILL_TRAINING_ADD_USER', 'a')
        // (this.managerOu && this.managerOu.length > 0) ||
        //localStorage.getItem('master_trainer') === 'true' 
        // this.trainer ||
        // this.branchTrainer,
      },
      {
        label: this.translate('My Training Courses (for trainers)'),
        icon: 'fa-solid fa-person-chalkboard',
        routerLink: '/training/trainer-courses',
        visible: this.trainer,
      },
      {
        label: this.translate('Password Reset'),
        routerLink: '/password-change',
        icon: 'pi pi-fw pi-key',
        visible: true,
      },
      {
        label: this.translate('Dashboard'),
        routerLink: '/admin/dashboards',
        icon: 'pi pi-fw pi-chart-bar',
        items: this.dashboard_items,
        visible:
          (this.permissionService.hasPermission('USER_MANAGEMENT', 'r') &&
            this.permissionService.hasPermission('OU', 'r')) ||
          (this.managerOu && this.managerOu.length > 0),
      },

    ];

    console.log('New Items', this.items);
  }

  allowedTags: string[] = this.permissionService.extractTags('GRAPHS', 'a')
  dashboard_items: any = [];

  private async getDashboards(): Promise<void> {

    let res = await this.dataService.postData('dashboards/unique-categories', {
      data: this.allowedTags,
    });
    if (res.error) {
      return;
    }
    console.log('this is the reply', res);

    res.data.forEach((data: {title: string, icon: string}) => {
      this.dashboard_items.push({
        label: this.translate(data.title),
        icon: data.icon,
        routerLink: '/admin/dashboards/' + data.title,
        visible: this.permissionService.hasPermission('GRAPHS', 'a'),
      });
    })
  }

  getOuType = async () => {
    try {
      const res = await this.dataService.postData(
        'training-type/get/?offset=1000&page=1',
        {}
      );
      if (res.error) {
        console.error('Error fetching data:', res.error);
        return;
      }
      if (res.data) {
        for (const item of res.data) {
          if (!this.fixedTrainingItemsIds.includes(item._id)) {
            // this.fixedTrainingItems = this.fixedTrainingItems.concat([
            //   {
            //     label: item.arabic,
            //     icon: item.icon,
            //     routerLink: '/training/skill-training/' + item._id,
            //     visible:
            //       this.permissionService.hasPermission('SKILL_TRAINING', 'r') ||
            //       (this.managerOu && this.managerOu.length > 0),
            //   },
            // ]);
          }
        }
        console.log('fixedTrainingItems', this.fixedTrainingItems);
        console.log('Items', this.items);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasPermissionRequest() {
    const permissionRequestsStr = localStorage.getItem('permissionRequests');
    const permissionRequests = !!permissionRequestsStr && permissionRequestsStr != "undefined" && permissionRequestsStr != "null" ? JSON.parse(permissionRequestsStr) : [];
    const isTester = localStorage.getItem('isTester')
    let x = (permissionRequests && permissionRequests.length > 0) || this.permissionService.hasPermission('PERMISSION_REQUESTS', 'r') || isTester;
    return (permissionRequests && permissionRequests.length > 0) || this.permissionService.hasPermission('PERMISSION_REQUESTS', 'r') || isTester;
  }

  handleLogout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  // Update methods to handle undefined labels
  toggleSubitems(itemLabel: string | undefined) {
    if (!itemLabel) return;
    this.expandedItems[itemLabel] = !this.expandedItems[itemLabel];
  }

  isItemExpanded(itemLabel: string | undefined): boolean {
    return itemLabel ? this.expandedItems[itemLabel] || false : false;
  }
}
